import { render, staticRenderFns } from "./KonvaDeleteElement.vue?vue&type=template&id=5d86cfbd&scoped=true"
import script from "./KonvaDeleteElement.vue?vue&type=script&lang=js"
export * from "./KonvaDeleteElement.vue?vue&type=script&lang=js"
import style0 from "./KonvaDeleteElement.vue?vue&type=style&index=0&id=5d86cfbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86cfbd",
  null
  
)

export default component.exports